import { useEffect } from 'react';
import { Progress } from 'src/components/progress/Progress';
import { useGetEnvironment, useGetProjectConfig } from 'src/hooks';
import { getAssetUrl, isProduction } from 'src/utils/environment';

import { FontsLoaderProps } from './ResourcesProvider.interface';

export const ResourcesProvider = (props: FontsLoaderProps) => {
  const { data: environment, isLoading: isEnvironmentLoading } =
    useGetEnvironment();
  const { data: projectConfig, isLoading: isProjectConfigLoading } =
    useGetProjectConfig(undefined, { staleTime: Infinity });

  if (projectConfig && environment) {
    window.environment.urls.assetUrl = isProduction()
      ? (window as any).environment?.hq
      : window.location.origin;
    if (!isProduction()) {
      // Local dev: apply VITE_GCF_* overrides even if the local project
      // config has no `gcf` section, so .env.local always wins here.
      const { apps } = projectConfig?.gcf ?? {};

      window.environment.urls.gcfCodUrl =
        import.meta.env.VITE_GCF_COD_URL ?? apps?.cod?.url;
      window.environment.urls.gcfComponentsUrl =
        import.meta.env.VITE_GCF_COMPONENTS_URL ?? apps?.components?.url;
      window.environment.urls.gcfPlayerUrl =
        import.meta.env.VITE_GCF_PLAYER_URL ?? apps?.player?.url;
    } else if (projectConfig.gcf) {
      const { apps } = projectConfig.gcf;

      window.environment.urls.gcfCodUrl = apps.cod.url;
      window.environment.urls.gcfComponentsUrl = apps.components.url;
      window.environment.urls.gcfPlayerUrl = apps.player.url;
    }
  }

  useEffect(() => {
    if (projectConfig && environment) {
      const fontNames = projectConfig?.fonts?.map((font) => font.name) ?? [];
      document.fonts.forEach((fontFace) => {
        if (fontNames.includes(fontFace.family)) {
          document.fonts.delete(fontFace);
        }
      });

      for (const font of projectConfig?.fonts ?? []) {
        const url = getAssetUrl(`/content/${font.font_zip}/${font.font_file}`);
        const loadFont = new FontFace(font.name, `url(${url})`);

        document.fonts.add(loadFont);
        loadFont.load();
      }
    }
  }, [projectConfig, environment]);

  if (isEnvironmentLoading || isProjectConfigLoading) return <Progress />;

  return <>{props.children}</>;
};
